<template>
  <div>
    <div style="margin-bottom:20px;" class="flex_start">
      <!-- search (string, optional): 搜索条件 资产名 资产类型 , -->
      <el-input
        style="width:200px"
        clearable
        v-model="params['search']"
        placeholder="输入资产名称/资产类型"
        size="small"
      >
        <i
          slot="suffix"
          style="font-size:14px"
          class="el-input__icon el-icon-search"
          @click.stop="tableSearch"
        ></i>
      </el-input>
      <x-Treeselect
        style="width:200px;margin-left:20px"
        class="Treeselect32"
        :defaultExpandLevel="Infinity"
        :placeholder="'选择组织查询'"
        @input="closeuseDeptselect"
        v-model="params['belongId']"
        :clearable="true"
        :multiple="false"
        :options="deptArr"
        value="id"
        label="deptName"
        id="id"
      ></x-Treeselect>
    </div>
    <x-table
      ref="xTable"
      url="/pc/asset/query"
      :axiosType="true"
      max-height="440"
      :params="params"
      @row-click="table_row_click"
      @selection-change="handleSelectionChange"
    >
      <el-table-column reserve-selection type="selection" width="55">
      </el-table-column>

      <el-table-column
        :label="item.label"
        show-overflow-tooltip
        :prop="item.model"
        v-for="item in columnArr"
        :key="item.label"
        ><template slot-scope="scope">
          <div style="width:100%" v-if="item.model == 'assetStatus'">
            <el-tag :style="assetStatusFulter(scope.row[item.model], false)">{{
              assetStatusFulter(scope.row[item.model], true)
            }}</el-tag>
          </div>
          <span
            @click="global_detals(scope.row.id)"
            style=" text-decoration:underline;cursor:pointer"
            v-else-if="item.model == 'assetCode' || item.model == 'assetName'"
            >{{ scope.row[item.model] }}</span
          >
          <span v-else>{{ scope.row[item.model] }}</span>
        </template></el-table-column
      >
    </x-table>
    <div class="dialog_bottom" style="margin-top:20px">
      <el-button class="dialog_close" size="small" @click="closeDialog"
        >取 消</el-button
      >
      <el-button
        class="dialog_submit"
        size="small"
        style="width:100px"
        type="submit32"
        @click="submit"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    managerId:{
      type:String,
      default:"",
    },
    queryType: { type: String, required: true },
    callBack: Function,
    defaultChecket: Array,
    deptId: {
      type: String,
      default: "",
    },
    columnArr: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      params: {
        managerId:this.managerId,
        queryType: this.queryType,
        deptId: this.deptId,
        belongId: null,
      },
      deptArr: [],
      selectData: [],
    };
  },
  mounted() {},
  methods: {
    table_row_click(row) {
      /* 

                @row-click="table_row_click"
           */
      this.$refs.xTable.set_checket(row);
    },
    closeuseDeptselect(data) {
      this.tableSearch();
    },

    init() {
      if (this.defaultChecket) {
        this.$refs.xTable.toggleRowSelection(this.defaultChecket);
      }
      this.$requestAxios(
        {
          url: "/pc/dept/tree",
          data: {},
        },
        (data) => {
          this.treelabelFulter(data.data, "deptName");
          this.deptArr = data.data;
        }
      );
    },
    /* 递归处理空的children */
    treelabelFulter(arr, label) {
      arr.forEach((item) => {
        item.label = item[label];
        if (item.children == [] || item.children == "") {
          delete item.children;
        }
        if (item.children && item.children.length) {
          this.treelabelFulter(item.children, label);
        }
      });
    },
    submit() {
      let ids = [];
      for (let i = 0; i < this.selectData.length; i++) {
        ids.push(this.selectData[i].id);
      }
      this.callBack(this.selectData, ids);
      this.closeDialog();
    },
    tableSearch() {
      this.$refs.xTable.search();
    },
    assetStatusFulter(data, flag) {
      let str = "";
      if (flag) {
        switch (data) {
          case "idle":
            str = "闲置";

            break;

          case "use":
            str = "在用";

            break;
          case "borrow":
            str = "借用";

            break;
          case "repair":
            str = "维修中";

            break;
          case "dispose":
            str = "处置";

            break;
          case "examine":
            str = "审批中";

            break;
        }
      } else {
        switch (data) {
          case "use":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "borrow":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "examine":
            str = "color:#436bff;background:#d8e6ff;";

            break;

          case "idle":
            str = "color:#42b983;background:#f0f9eb;";

            break;
          case "dispose":
            str = "color:#ffa200;background:#ffefd8;";
            break;
          case "repair":
            str = "color:#ffa200;background:#ffefd8;";
            break;
        }
      }
      return str;
    },
    handleSelectionChange(data) {
      this.selectData = data;
    },
  },
};
</script>
<style scoped></style>
